import { render } from "./RegisterPrivateSale.vue?vue&type=template&id=51336260&scoped=true"
import script from "./RegisterPrivateSale.vue?vue&type=script&lang=js"
export * from "./RegisterPrivateSale.vue?vue&type=script&lang=js"

import "./custom-register-private-sale.scss?vue&type=style&index=0&id=51336260&lang=scss&scoped=true"
import "./custom-invite.scss?vue&type=style&index=1&id=51336260&lang=scss&scoped=true"
import "./RegisterPrivateSale.vue?vue&type=style&index=2&id=51336260&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51336260"]])

export default __exports__